import React from 'react'
import { withRouter } from "react-router-dom";
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ClassIcon from '@material-ui/icons/Class';
import PersonIcon from '@material-ui/icons/Person';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import UsuarioContext from '../contex/UsuarioContext';
import AddBoxIcon from '@material-ui/icons/AddBox';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { FirebaseContext } from '../../firebase';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

const Listas = (props) => {

  const [selectedIndex, setSelectedIndex] = React.useState(1);


  const { firebase, user } = React.useContext(FirebaseContext); 
  const [examenes, setExamenes] = React.useState([])

       ////////////////////////////////////////////////////////////////////  
       const usuarioContextLocal = React.useContext(UsuarioContext);
       const { setObjUsuario, objUsuario } = usuarioContextLocal;
       
       React.useEffect(() => {
           firebase.db.collection("colUsuarios").where("id", "==", user.uid).get().then(snapshot => {
               const arrayUsuario = snapshot.docs.map(doc => {
                   let data = doc.data();
                   let id = doc.id;
                   return { id, ...data };
               });            
               setObjUsuario(arrayUsuario[0]);    
           });
       }, [])
   ///////////////////////////////////////////////////////////////////////////



  // const usuarioContextLocal = React.useContext(UsuarioContext);

  // const { objUsuario } = usuarioContextLocal;

  const rol = objUsuario.rol

  return (
    <div>
      <List>

        <ListItem
          button
          selected={selectedIndex === 1}
          onClick={() => {
            props.history.push("/perfil")
            setSelectedIndex(1)

          }}>
          <ListItemIcon>
            <PersonIcon style={{ color: '#FFFFFF' }} />
          </ListItemIcon>
          <ListItemText style={{ color: '#FFFFFF' }} primary={"Perfil"} />
        </ListItem>

        {
          rol >= 4 ? (
            <ListItem
              button
              selected={selectedIndex === 2}
              onClick={() => {
                props.history.push("/admusuarios")
                setSelectedIndex(2)
              }}>
              <ListItemIcon>
                <PeopleAltIcon style={{ color: '#FFFFFF' }} />
              </ListItemIcon>
              <ListItemText style={{ color: '#FFFFFF' }} primary={"Usuarios"} />
            </ListItem>

          ) : null
        }

        {
          rol >= 4 ? (
            <ListItem
              button
              selected={selectedIndex === 3}
              onClick={() => {
                props.history.push("/admexamenes")
                setSelectedIndex(3)
              }}>
              <ListItemIcon>
                <AddBoxIcon style={{ color: '#FFFFFF' }} />
              </ListItemIcon>
              <ListItemText style={{ color: '#FFFFFF' }} primary={"Examenes"} />
            </ListItem>

          ) : null
        }

        {
          rol >= 4 ? (
            <ListItem
              button
              selected={selectedIndex === 4}
              onClick={() => {
                props.history.push("/admin")
                setSelectedIndex(4)
              }}>
              <ListItemIcon>
                <ScheduleIcon style={{ color: '#FFFFFF' }} />
              </ListItemIcon>
              <ListItemText style={{ color: '#FFFFFF' }} primary={"Programación"} />
            </ListItem>
          ) : null
        }

{
          rol >= 4 ? (
            <ListItem
              button
              selected={selectedIndex === 5}
              onClick={() => {
                props.history.push("/adm/login")
                setSelectedIndex(5)
              }}>
              <ListItemIcon>
                <PersonAddIcon style={{ color: '#FFFFFF' }} />
              </ListItemIcon>
              <ListItemText style={{ color: '#FFFFFF' }} primary={"Usuarios"} />
            </ListItem>
          ) : null
        }


      </List>
      <Divider style={{ background: '#FFFFFF' }} />

      { rol >= 1 ? (
      <ListItem
        button
        selected={selectedIndex === 10}
        onClick={() => {
          props.history.push("/ciclos")
          setSelectedIndex(10)
        }}>
        <ListItemIcon>
          <ClassIcon style={{ color: '#FFFFFF' }} />
        </ListItemIcon>
        <ListItemText style={{ color: '#FFFFFF' }} primary={"Clases"} />
      </ListItem>
      ) : null }

      { rol >= 1 ? (
          <ListItem
            button
            selected={selectedIndex === 11}
            onClick={() => {
              props.history.push("/examenes")
              setSelectedIndex(11)
            }}>
            <ListItemIcon>
              <NoteAddIcon style={{ color: '#FFFFFF' }} />
            </ListItemIcon>
            <ListItemText style={{ color: '#FFFFFF' }} primary={"Examenes"} />
          </ListItem>
        ) : null }

    </div>
  )
}

export default withRouter(Listas)
